import { render, staticRenderFns } from "./workshopTraffic.vue?vue&type=template&id=2b02ada3&scoped=true"
import script from "./workshopTraffic.vue?vue&type=script&lang=js"
export * from "./workshopTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02ada3",
  null
  
)

export default component.exports